export default {"src":"/_next/static/media/0xd3d2e2692501a5c9ca623199d38826e513033a17.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};